import { AuthState, JWTActions } from '../types';

export const JWTReducer = (state: AuthState, action: JWTActions) => {
  const {
    type,
    payload: { isAuthenticated, user, jwt },
  } = action;
  switch (type) {
    case 'INITIALIZE':
      return {
        isAuthenticated,
        isInitialized: true,
        user,
        isReady: true,
        jwt,
        logoutRedirect: false,
      };
    case 'LOGIN':
      return {
        ...state,
        isAuthenticated,
        user,
        isReady: true,
        jwt,
      };

    case 'VERIFY_TOKEN':
      return {
        ...state,
        isAuthenticated,
        user,
        isReady: true,
        jwt,
      };

    case 'LOGOUT':
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        isReady: true,
        jwt: null,
        logoutRedirect: true,
      };
    case 'REGISTER':
      return {
        ...state,
        isAuthenticated,
        user,
        isReady: true,
        jwt,
      };
    case 'RESET_PASSWORD':
      return {
        ...state,
        isAuthenticated,
        isReady: true,
        user,
        jwt,
      };
    default:
      return state;
  }
};
